import {Inject, Injectable} from '@angular/core';
import {WINDOW} from '@app/core/global/global.const';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '@env/environment';

@Injectable()
export class HostService {

    constructor(@Inject(WINDOW) private window: Window,
                private http: HttpClient) {
    }

    getHostname(): string {
        return this.window.location.hostname.toLowerCase();
    }

    getUrlOfPassport(): Observable<any> {
        return this.http.get<any>(`${environment.datahubBaseURI}/api/v2/service/goto/passport`);
    }

    openNewWindow(redirectUrl: string): boolean {
        const newWindow = window.open('', 'passport', '');
        if (newWindow !== null) {
            newWindow.location.href = redirectUrl;
            return true;
        } else {
            return false;
        }
    }
}
